import React, { useEffect,  useState } from "react";
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import 'primeflex/primeflex.css';
import '../css/ProTree.css';
import _ from 'lodash'
import { ExpandAll } from "../../utilities/TreeHelper";

const ProTreeTable = ({treeData,  searchValue, config, OnTreeNodeSelect, defaultSelectionKey = "", defaultExpandedKeys = {}, isFilterApplied = false })=>{ 
    const [selectionKey, setSelectionKey] = useState(defaultSelectionKey);
    const [expandedKeys, setExpandedKeys] = useState(defaultExpandedKeys);   

   useEffect(()=>{        
        if(!_.isEmpty(defaultExpandedKeys))
            setExpandedKeys(defaultExpandedKeys) 
   }, [defaultExpandedKeys])

   useEffect(()=>{
        setSelectionKey(defaultSelectionKey)
   }, [defaultSelectionKey])

   useEffect(()=>{      
       let keysToExpand = {}
       !_.isEmpty(searchValue) && _.forEach(treeData, (tree)=>{keysToExpand = {...keysToExpand, ...ExpandAll(tree, keysToExpand)};  setExpandedKeys(keysToExpand)})
      
       if(_.isEmpty(searchValue) && !isFilterApplied)
            setExpandedKeys({})   

   }, [searchValue, isFilterApplied])

   const rowClassName = (node) => {       
        return  _.isEqual(node.type, "BED") && { 'p-highlight-treenode-bed': node.key === selectionKey } 
                                            //: { 'p-highlight-treenode': node.key === selectionKey } ;
}

    return (   
        <TreeTable value={treeData} stripedRows={true} expandedKeys={expandedKeys} onToggle={(e)=>setExpandedKeys(e.value)} 
                   selectionKeys={selectionKey} selectionMode="single" globalFilter={searchValue} onSelect={OnTreeNodeSelect}
                   onSelectionChange={e=> setSelectionKey(e.value)} rowClassName={rowClassName} > 
               {config.map((c, index)=>{
                   return <Column key={index} body={c.actionTemplate} field={c.field}  expander = {c.expander} style={c.style}></Column>
               })} 
        </TreeTable>
    )
}

export default ProTreeTable;